<span>{{ countries[countryCode]?.regions?.[regionCode] ?? (regionCode || allRegions) }}</span>
